import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Minimize } from "lucide-react";
 * // Use <Minimize /> instead
 */
export const FullscreenOffIcon = createSVGWrapper(
  <>
    <path
      d="M8 10C9.10457 10 10 9.10457 10 8L10 3H8L8 8L3 8V10L8 10Z"
      fill="currentColor"
    />
    <path
      d="M8 14C9.10457 14 10 14.8954 10 16L10 21H8L8 16L3 16V14L8 14Z"
      fill="currentColor"
    />
    <path
      d="M14 8C14 9.10457 14.8954 10 16 10L21 10V8L16 8L16 3H14L14 8Z"
      fill="currentColor"
    />
    <path
      d="M16 14C14.8954 14 14 14.8954 14 16L14 21H16L16 16L21 16V14L16 14Z"
      fill="currentColor"
    />
  </>
);
